import { Chart, GoogleChartOptions } from 'react-google-charts';

export const defaultData = [
  ['Task', 'Hours per Day'],
  ['Google', 11],
  ['Facebook', 2],
  ['Yelp', 2],
  ['Trustpilot', 2],
];

export const options: Partial<GoogleChartOptions> = {
  pieHole: 0.4,
  is3D: false,
  legend: {
    position: 'right',
    alignment: 'center',
  },
  allowHtml: true,
};

export const DonutChart = ({ data = defaultData, opt, width = 350, height = 350 }: { data?: (string | number)[][]; opt?: Partial<GoogleChartOptions>; width?: number | string; height?: number | string; }) => {
  return (
    <Chart
      chartType="PieChart"
      width={typeof width === 'number' ? `${width}px` : width}
      height={typeof height === 'number' ? `${height}px` : height}
      data={data}
      options={{ ...options, ...opt }}
      legendToggle={false}
    />
  );
};
